export default "__VITE_ASSET__D8k2pYad__"